<template>
  <v-card>
    <v-toolbar flat>
      <span class="headline">Cancel Changes</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-container>
      <v-data-table
        v-model="selected"
        :headers="headers.CancelChangesHeader"
        :items="desserts"
        :single-select="singleSelect"
        :loading="loading"
        :footer-props="footerProps"
        :options.sync="options"
        :server-items-length="options.pageCount"
        item-key="id"
        show-select
        class="elevation-1"
      >
        <template v-slot:item.changeType="{ item }">
          {{ assist.tool.getEnumTextByValue(assist.dataType.ChangeTypeEnum, item.changeType) }}
        </template>
        <template v-slot:item.details="{ item }">
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="clickMoreDetailsEventHandler(item)">
                <v-icon color="primary">drag_indicator</v-icon>
              </v-btn>
            </template>
            <span>More Details</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <v-card-actions class="footer">
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="cancelChanges">OK</v-btn>
      <v-btn color="primary" text @click="hideDialog">Close</v-btn>
    </v-card-actions>
    <v-dialog v-model="dialog.display" persistent max-width="1600px">
      <more-details-dialog
        :otherDiffData="diffData"
        :diffData="paymentInstallmentDiffData"
        :headers="headers.PaymentInstallmentMoreDetailsHeader"
        :tableHeight="500"
        :hasBeforeAfter="true"
        @hideDialog="triggerMoreDetailsDialog(false)"
      ></more-details-dialog>
    </v-dialog>
  </v-card>
</template>

<script>
import { DataType, Tool, Popup } from '@/util/index'
import { LIST_TABLE_HEADER } from '@/setting/list-header/list-table-header'
import MoreDetailsDialog from './MoreDetailsDialog'
import { ProcessingApi } from '@/api/pandaria'

const tool = new Tool()
const popup = new Popup()
export default {
  name: 'cancel-changes-dialog',
  components: { MoreDetailsDialog },
  props: {
    loan: {
      type: Object,
      default: () => {}
    },
    display: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      assist: {
        tool: new Tool(),
        dataType: DataType
      },
      headers: LIST_TABLE_HEADER,
      singleSelect: true,
      selected: [],
      loading: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        pageCount: 0
      },
      pagination: {
        index: 1,
        size: 10,
        orderBy: null
      },
      footerProps: {
        'items-per-page-options': [10, 20, 50, -1]
      },
      desserts: [],
      dialog: {
        display: false
      },
      paymentInstallmentDiffData: {
        original: [],
        current: []
      },
      diffData: {}
    }
  },
  computed: {
    requestLoanId () {
      switch (this.loan.loanType) {
        case DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value:
          return this.store.getters.getPPSFirstValidSlaveLoanId
        case DataType.LoanTypeEnum.INSTALLMENT_LOAN.value:
        default:
          return this.loan.id
      }
    }
  },
  watch: {
    display (val) {
      val && this.searchData()
    },
    'options.page': {
      handler (val) {
        this.pagination.index = val
        this.pagination.size = this.options.itemsPerPage
        this.searchData()
      }
    },
    'options.itemsPerPage': {
      handler (val) {
        this.pagination.index = this.options.page
        this.pagination.size = val
        this.searchData()
      }
    }
  },
  mounted () {
    this.searchData()
  },
  methods: {
    searchData () {
      const $this = this
      let requestData = {}
      if (this.$route.path.includes(DataType.LoanPhaseEnum.LOAN_COLLECTION.abbr)) {
        requestData = {
          loanId: $this.requestLoanId,
          pageSize: $this.pagination.size,
          pageNum: $this.pagination.index,
          lcs: true
        }
      } else {
        requestData = {
          loanId: $this.requestLoanId,
          pageSize: $this.pagination.size,
          pageNum: $this.pagination.index
        }
      }
      ProcessingApi.cancelDetail(requestData, function (result) {
        if (tool.isNotEmpty(result)) {
          $this.paymentInstallmentDiffData.original = JSON.parse(result.installmentInDB)
          $this.desserts = result.detail
          $this.options.pageCount = result.count
        }
      }, function (result) {
        window._VMA.$emit('SHOW_SNACKBAR', { text: result.message, color: 'error' })
        $this.paymentInstallmentDiffData.original = []
        $this.desserts = []
        $this.options.pageCount = 0
      })
    },
    cancelChanges () {
      const $this = this
      const selected = $this.selected
      if (tool.isEmpty(selected)) {
        popup.popupForWarning('Please select one data')
        return
      }
      let requestData = {}
      if (this.$route.path.includes(DataType.LoanPhaseEnum.LOAN_COLLECTION.abbr)) {
        requestData = {
          id: selected[0].id,
          lcs: true
        }
      } else {
        requestData = {
          id: selected[0].id
        }
      }
      ProcessingApi.cancelOperation(requestData, function (result) {
        popup.popupForSuccess('Success to cancel change')
        $this.hideDialog()
        $this.cancelCallback()
      }, function (result) {
        popup.popupForWarning(result.message)
      })
    },
    cancelCallback () {
      if (this.loan.loanType === DataType.LoanTypeEnum.MULTIPLE_ADVANCE_LOAN.value) {
        this.$eventBus.$emit('get-latest-slave-detail-event', 'update loan history')
      } else if (this.loan.loanType === DataType.LoanTypeEnum.INSTALLMENT_LOAN.value) {
        this.$eventBus.$emit('get-clicked-slave-detail-event', { loanId: this.currentLoanId })
        this.$eventBus.$emit('get-installment-status-event', { loanId: this.currentLoanId })
      }
    },
    clickMoreDetailsEventHandler (item) {
      const $this = this
      $this.paymentInstallmentDiffData.current = item.originalInstallmentList
      $this.diffData = item.different
      this.triggerMoreDetailsDialog(true)
    },
    triggerMoreDetailsDialog (flag) {
      this.dialog.display = flag
    },
    hideDialog () {
      this.$emit('hideDialog')
    }
  }
}
</script>
